import * as React from "react";

export interface DataViewProps {
    value: string | undefined;
    dateFormat?: "fss";
    format?: string;
}

export function DateView(props: DataViewProps): JSX.Element {
    let resultValue;
    if (props.dateFormat == "fss") {
        resultValue = props.value?.split("-").reverse().join(".") ?? "";
    } else {
        resultValue = props.value?.split("-").join(".") ?? "";
    }
    return <>{resultValue}</>;
}
